import { render } from "./BaseAlert.vue?vue&type=template&id=31affb06"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"
script.render = render

export default script